import { render, staticRenderFns } from "./TabFloor.vue?vue&type=template&id=7c2244cc"
import script from "./TabFloor.vue?vue&type=script&lang=js"
export * from "./TabFloor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports